import SavingsAutoDepositsShow from "components/manage/savings/auto_deposits/show.vue";

$(() => {
  new Vue({
    el: document.querySelector(".v-manage-savings-auto-deposits-show-controller"),
    components: { SavingsAutoDepositsShow },
  });
});
